import { render } from "./FillToggleIcon.svg?vue&type=template&id=3c1432ab"
const script = {}
script.render = render

export default script